import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [result, setResult] = useState({ message: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      navigate('/admin/panel');
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResult({ message: 'در حال ورود...', type: 'loading' });

    try {
      const response = await axios.post('/api/admin/login', credentials);

      if (response.data.token) {
        localStorage.setItem('admin_token', response.data.token);
        setResult({ message: 'ورود موفق!', type: 'success' });
        navigate('/admin/panel');
      }
    } catch (error) {
      setResult({
        message: error.response?.data?.error || 'خطا در برقراری ارتباط',
        type: 'error'
      });
    }

    setIsLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>ورود مدیران</h1>
        <p className="login-subtitle">برای مدیریت درخواست‌ها وارد شوید</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-col">
            <label htmlFor="username">نام کاربری</label>
            <input
              id="username"
              type="text"
              name="username"
              value={credentials.username}
              onChange={handleInputChange}
              autoComplete="username"
              required
            />
          </div>

          <div className="form-col">
            <label htmlFor="password">رمز عبور</label>
            <input
              id="password"
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleInputChange}
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className="submit-btn" disabled={isLoading}>
            {isLoading ? 'در حال ورود...' : 'ورود'}
          </button>
        </form>

        {result.message && (
          <div className={`result-message ${result.type}`}>{result.message}</div>
        )}

        <a href="/" className="back-link">بازگشت به فرم درخواست</a>
      </div>
    </div>
  );
};

export default AdminLogin;
